import React, { useContext, useEffect, useRef, useState } from "react";
// import { useHistory } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/advance/Loading";
import Modal from "../../components/advance/Modal";
// import Button from "../../components/core/Button";
import OTPInput from "../../components/base/OtpInput.js";
import Button from "../../components/core/EPL_Button_Think";
import SubTitle from "../../components/core/SubTitle";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import "../../css/main.css";
import useMediaQuery from "../../hooks/useMediaQuery";
import ErrorModal from "../../modals/ErrorModal";
import ProfessionalEMailSentModal from "../../modals/ProfessionalEMailSentModal";
import { ConstantContext } from "../../shared/context/ConstantContext";
import { UserContext } from "../../shared/context/UserContext";
import { isValidEmail } from "../../shared/validations/Email";
import { isValidPincode } from "../../shared/validations/Pincode";
import { isValidGstNumber } from "../../shared/validations/GSTNumber.js";
import { isValidUDYAMNumber } from "../../shared/validations/UDYAMNumber.js";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import { ProfessionalDetailsWrapper } from "./_styles/ProfessionalDetailsWrapper";
import moengage from "@moengage/web-sdk";
// const getInternalStage = (stage, stage_status) => {
//   if (stage === 'EMAIL' && stage_status === 'INIT') {
//     return 'EMAIL_INIT';
//   } else if (stage === 'EMAIL' && stage_status === 'INCOMPLETE') {
//     return 'EMAIL_INCOMPLETE';
//   } else if (stage === 'EMAIL' && stage_status === 'COMPLETE') {
//     return 'EMAIL_COMPLETE';
//   } else if (stage === 'PROFESSIONAL_DETAILS' && stage_status === 'COMPLETE') {
//     return 'PROFESSIONAL_DETAILS_COMPLETE';
//   } else if (stage === 'CE' && stage_status === 'INIT') {
//     return 'CE_INIT';
//   } else if (stage === 'CE' && stage_status === 'INCOMPLETE') {
//     return 'CE_INCOMPLETE';
//   } else {
//     return 'PROFESSIONAL_DETAILS_INIT';
//   }
// };
import {
  GetCustomerDetailsContext,
  GetCustomerDetails,
  validateInputExistenece,
} from "../../App";
import {
  BEUREU_POLLING,
  DS_PARSER,
  GET_CONSTANTS,
  INSERT_PROFESSIONAL_DETAILS,
  INSERT_SELF_EMPLOYED_DETAILS,
  KARZA_CHECK,
  PINCODE_MASTER,
  SEND_EMAIL_OTP,
  VERIFY_EMAIL_OTP,
  call_UPSELL_CE,
  GET_ORG_NAME,
  BUREAU_CIBIL,
  GST_SEARCH,
  GST_VERIFY_DETAILS,
  GST_GET_DETAILS,
  GST_RETURN_DETAILS,
} from "../../Config";
import icon_modal from "../../assets/svg/EPL_think_svg/Icon_modal.svg";
import timer from "../../assets/svg/EPL_think_svg/timer.svg";
import FloatingInput from "../../components/base/FloatingInput";
import { updateLead } from "../../shared/services/crm";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { isValidName } from "../../shared/validations/Name";
import { isValidNumber } from "../../shared/validations/Numeric";
import { isValidOTP } from "../../shared/validations/OTP";
import isEmpty from "../../shared/validations/common/isEmpty";
import poll from "../../utils/poll";
import {
  CompanyCategoryReject,
  DsEligibilityFailed,
  IncorrectOtpModal,
  IncorrectPinCodeModal,
  KarzaFailed,
  MaxOtpRetryModal,
  OtpExpiredModal,
  ResendOtpEmailModal,
  SelfEmpWarnModal,
  DSAsyncRetryModal,
  CheckInternetModal,
  GenericEmailCheck,
  CompanyNameWarnModal,
  SelfEmployedLeadCapturedModal,
} from "../other-pages/Modals/AllModal";
import { isStageLogin } from "../../shared/validations/StageLogin.js";
import isEnglish, { isEnglishNewCheck } from "../../shared/validations/isEnglish.js";
import ScenarioBasedModal from "../other-pages/Modals/ScenarioBasedModal.js";
import { encryptedData } from "../../utils/index.js";

const ProfessionalDetails = (props) => {
  moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // const [customerDetails, setCustomerDetails] = useState(props.customerDetails);
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(true);

  useEffect(async () => {

    isStageLogin(   
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );
    setIsValidOthCompName(true);
    if (customerDetails?.stage === "PROFESSIONAL_VERIFY") {
      setShowOtpModal(true);
    }
    // window.scrollTo(0, 0);
    // getConstants();
    // await GetCustomerDetails(
    //   customerDetails.application_form_number,
    //   customerDetails.source,
    //   customerDetails,
    //   setCustomerDetails
    // );
    if (customerDetails.source === "upsell") {
      // setPAN(customerDetails);
    }
    setDataCaptured(true);
    if (customerDetails?.Data?.isTruncated == true || customerDetails?.Data?.isTruncated === "True"){
			setEmploymentType("self_employed");
			fetchGSTNumbers()
		}
    // console.log("TESTING ->", customerDetails);
  }, []);

  useEffect(async () => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("ProfessionalDetails customerDetails: ", customerDetails);
      setShowShimmer(false);
      // TODO: Mostly No need of stage here...

      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);

      if (customerDetails?.Data?.isError === "True") {
        console.log(">>>><<<<<<<<<<");
        if (parseInt(customerDetails?.Data?.retry_count) > 0) {
          // if (customerDetails?.Data?.api_name === "employmentCheck") {
          //   console.log(
          //     ">>>>>>>>>>>>>>>><<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<"
          //   );
          //   await karzaAPI();
          // }
          // if (customerDetails?.Data?.api_name === "bureauCall") {
          //   await callCibil();
          // }
          // if (customerDetails?.Data?.api_name === "bureauCheckStatus") {
          //   await beureuPolling();
          // }
          // if (customerDetails?.Data?.api_name === "dsCallSync") {
          //   await dsParserCall();
          // }
          if (customerDetails?.Data?.api_name === "callCEUpsell") {
            callCE();
          }
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      } else {
        navigate(`${route}`, {
          replace: true,
          state: {
            customerDetails: customerDetails,
          },
        });
      }
    } else {
      // console.log("ProfessionalDetails Ouch customerDetails ");
    }
  }, [customerDetails]);

  const { setConstant } = useContext(ConstantContext);
  const [employmentType, setEmploymentType] = useState("Salaried");
  const [additionalConfirm, setAdditionalConfirm] = useState("Salaried");
  const updateAdditionalConfirm = (e) => {
    setAdditionalConfirm(e.target.value);
    // console.log("selected", e.target.value);
    if (e.target.value == "self_employed") {
      // console.log("heeeerrereer");
      setSelfEmpWarn(true);
    }
  };
  const [companyNameWarn, setCompanyNameWarn] = useState(false);
  const [selfEmpWarn, setSelfEmpWarn] = useState(false);
  const [consentCheckbox, setConsentCheckbox] = useState(true);
  const [dropDownLabels, setDropDownLabels] = useState([]);
  const [fetched, setFetched] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [enableResendOtp, SetEnableResendOtp] = useState(false);
  const [seconds, setSeconds] = useState();
  const [minutes, setMinutes] = useState();
  const [showOtpExpiredModal, setShowOtpExpiredModal] = useState(false);
  const [internetCheck, setInternetCheck] = useState(false);
  const [resendOtp, setResendOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [showMaxRetryModal, setShowMaxRetryModal] = useState(false);
  const [isOtpwrong, SetIsOtpWrong] = useState(false);
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [dataCaptured, setDataCaptured] = useState();
  const [isDSEligibilityFailed, setIsDSEligibilityFailed] = useState(false);
  const [dsAsyncRetryModal, setDsAsyncRetryModal] = useState(false);
  const [companyValid, SetCompanyValid] = useState(false);
  const [domainEmailCheck, setDomainEmailCheck] = useState(false);

  const [companyType, setCompanyType] = useState();
  const [isCompanyType, setIsCompanyType] = useState(false);
  const [othersCompanyName, setOthersCompanyName] = useState("");
  const [isOthers, setIsOthers] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [gst, setGst] = useState("");
  const [udyam, setUdyam] = useState("");
  const [gstNumberError, setGstNumberError] = useState(false);
  const [UdyamNumberError, setUdyamNumberError] = useState(false);
  const [gstNumber, setGstNumber] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [loanAmountError, setLoanAmountError] = useState(false);
  const [UdyamNumber, setUdyamNumber] = useState("");
  const [incorporationOptions, setIncorparationOptions] = useState([]);
  const [dateOfIncorporation, setDateOfIncorporation] = useState("");
  const incorporationLabels = [
    "Sole Proprietorship Registration",
    "One-person Company Registration",
    "Partnerships Firm Registration",
    "Limited Liability Partnership (LLP)",
    "Private Limited Company Registration",
    "Public Limited Company Registration",
    "Section 8 Company Registration",
  ];
  const [selectedIncorporationOption, setSelectedIncorporationOption] =
    useState("");
  const [monthlyIncomeOptions, setMonthlyIncomeOptions] = useState([]);
  const monthlyIncomeLabels = [
    "Less than 25,000",
    "25,000 - 49,999",
    "50,000 - 74,999",
    "75,000 - 99,999",
    "1,00,000 - 1,99,999",
    "2,00,000 and Above"
  ];
  const [selectedMonthlyIncomeOption, setSelectedMonthlyIncomeOption] = useState("");
  const [gstNumberDisabled, setGstNumberDisabled] = useState(false);
  const [gstNumberOptions, setGstNumberOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const isFirstSelectionRef = useRef(true);
  const previousGstNumberRef = useRef("");

  const updateLoanAmount = (e) => {
    setLoanAmount(e.target.value);
    console.log(e.target.value.length);
    if (
      e.target.value.length == 0 ||
      e.target.value < 50000 ||
      e.target.value > 5000000
    ) {
      setLoanAmountError(true);
    } else {
      setLoanAmountError(false);
    }
  };

  const updateEmploymentType = (e) => {
    if (e.target.value === "self_employed") {
      fetchGSTNumbers()
    }
    setEmploymentType(e.target.value);
    setCompanyName("");
    setGstNumber("");
    setCompanyNameDisabled(false)
  };

  const fetchGSTNumbers = async () => {
    setShowShimmer(true);
    try {
      const payload = {
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));

      const response = await sendRequest(
        "/" + customerDetails.source + GST_SEARCH,
        formData
      );
      if (response.response.Success) {
        response.response.Data.push("None Of The Above")
        setGstNumberOptions(createGSTDropDownOptions(response.response?.Data));
      } else {
        setGstNumberOptions(null);
      }
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  const createGSTDropDownOptions = (gstNumbers, isFilter = false, filterText = "") => {
    const options = [];
    for (let i = 0; i < gstNumbers.length; i++) {
      if (
        isFilter &&
        gstNumbers[i]?.toLowerCase().indexOf(filterText.toLowerCase()) > -1
      ) {
        options.push({
          label: gstNumbers[i],
          value: gstNumbers[i],
          func: () => {
            setGstNumber(gstNumbers[i]);
            handleGstSelection(gstNumbers[i]);
            showDropdownGST("GSTNumber");
          },
        });
      } else if (!isFilter) {
        options.push({
          label: gstNumbers[i],
          value: gstNumbers[i],
          func: () => {
            setGstNumber(gstNumbers[i]);
            handleGstSelection(gstNumbers[i]);
            showDropdownGST("GSTNumber");
          },
        });
      }
    }
    if (options.length === 0) {
      options.push({
        label: "Not Found",
        value: "Not Found",
        func: () => {
          filterText = "";
          isFilter = false;
          setGstNumber("");
          showDropdownGST("GSTNumber");
        },
      });
    }
    return options;
  };

  const handleGstSelection = (gst) => {
    if (gst === "None Of The Above") {
      setCompanyName("");
      setCompanyNameDisabled(false)
      previousGstNumberRef.current = gst;
      return;
    }
    if (isFirstSelectionRef.current) {
      fetchGstDetails(gst);
      previousGstNumberRef.current = gst;
      isFirstSelectionRef.current = false;
    } else {
      if (previousGstNumberRef.current === "None Of The Above") {
        fetchGstDetails(gst);
        previousGstNumberRef.current = gst;
      } else if (gst !== previousGstNumberRef.current) {
        setShowModal(true);
      }
    }
  };  

  const fetchGstDetails = async (selectedGstNumber) => {
    setShowShimmer(true);
    try {
      const payload = {
        gst_number: selectedGstNumber,
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));

      const response = await sendRequest(
        "/" + customerDetails.source + GST_GET_DETAILS,
        formData
      );
      if (response.response.Success) {
        if (response?.response?.Data?.name_of_business) {
          setCompanyName(response?.response?.Data?.name_of_business)
          setCompanyNameDisabled(true)
        }
      }
      setShowShimmer(false);
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  const gstReturnDetails = async () => {
    setShowShimmer(true);
    try {
      const payload = {
        gst_number: gstNumber
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));

      const response = await sendRequest(
        "/" + customerDetails.source + GST_RETURN_DETAILS,
        formData
      );
      if (response.response.Success) {
				await gstVerifyDetails()
			} else {
				await insertSelfEmployedDetails()
			}
      setShowShimmer(false);
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  const gstVerifyDetails = async () => {
    setShowShimmer(true);
    try {
      const payload = {
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));

      const response = await sendRequest(
        "/" + customerDetails.source + GST_VERIFY_DETAILS,
        formData
      );
      if (response.response.Success) {
				await insertSelfEmployedDetails()
			} else {
				await insertSelfEmployedDetails()
			}
      setShowShimmer(false);
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  const handleConfirmChange = async () => {
    await fetchGstDetails(gstNumber); // Fetch details for the new GST number
    previousGstNumberRef.current = gstNumber; // Update previous GST number
    setShowModal(false); // Close the modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close the modal
    setGstNumber(previousGstNumberRef.current); // Reset to previous GST number
  };

  const updateCompanyType = (e) => {
    setCompanyType(e.target.value);
    setIsCompanyType(true);
  };

  const [isValidOthCompName, setIsValidOthCompName] = useState(false);

  const updateOthersCompanyName = (e) => {
    e.target.value = e.target.value.toLocaleUpperCase();
    setOthersCompanyName(e.target.value);
    const othComNameRegex = /^[a-z A-Z0-9.]+$/;
    const isValid =
      othComNameRegex.test(e.target.value) &&
      /[a-zA-Z0-9]/.test(e.target.value);

    if (isValid) {
      setIsValidOthCompName(true);
    } else {
      setIsValidOthCompName(false);
    }
  };

  const updateGst = (e) => {
    setGst(e.target.value);
    if(e.target.value === "No"){
      setGstNumber("");
    }
  };

  const updateGstNumber = (e) => {
    setGstNumber(e.target.value);
    if (e.target.value.length === 15) {
      if (isValidGstNumber(e.target.value)) {
        setGstNumberError(false);
      }
    } else {
      setGstNumberError(true);
    }
  };

  const updateUdyamNumber = (e) => {
    setUdyamNumber(e.target.value);
    if (e.target.value.length === 19) {
      if (isValidUDYAMNumber(e.target.value)) {
        setUdyamNumberError(false);
      }
    } else {
      setUdyamNumberError(true);
    }
  };

  const updateUdyam = (e) => {
    setUdyam(e.target.value);
    if(e.target.value === "No"){
      setUdyamNumber("");
    }
  };

  const isValidDate = (dateString) => {
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;

    if (!dateRegex.test(dateString)) {
      return false;
    }
    const [day, month, year] = dateString.split("/").map(Number);

    if (month < 1 || month > 12) {
      return false;
    }

    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      return false;
    }

    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

    if (month === 2) {
      if (isLeapYear && day > 29) {
        return false;
      } else if (!isLeapYear && day > 28) {
        return false;
      }
    }
    if (year < 1000 || year > 9999) {
      return false;
    }

    // Calculate age
    const currentDate = new Date();
    const birthDate = new Date(year, month - 1, day); // Note: Month is 0-indexed in JavaScript Date

    const age = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDiff = currentDate.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())
    ) {
      // Subtract 1 year if birthdate hasn't occurred yet this year
      return age - 1 >= 0 && age - 1 <= 100;
    } else {
      return age >= 0 && age < 100;
    }
  };

  const updateDateOfIncorporation = (e) => {
    let dateInput = e.target.value;
    let value = dateInput.replace(/\D/g, "");

    if (dateInput.length <= 10) {
      if (value.length > 2) {
        value = value.slice(0, 2) + "/" + value.slice(2);
      }
      if (value.length > 5) {
        value = value.slice(0, 5) + "/" + value.slice(5);
      }
      setDateOfIncorporation(value);
      console.log(value.length);
      if (value.length === 10) {
        setDateError(!isValidDate(value));
      } else {
        setDateError(true);
      }
    }
  };

  // const insertSelfEmployeDetails = async () => {
  //   const [day, month, year] = dateOfIncorporation.split("/").map(Number);
  //   const dateObject = new Date(year, month - 1, day);
  //   let modifiedDate = "";
  //   const yyyy = dateObject.getFullYear().toString().padStart(4, "0");
  //   const mm = (dateObject.getMonth() + 1).toString().padStart(2, "0");
  //   const dd = dateObject.getDate().toString().padStart(2, "0");

  //   // Concatenate the components in "yyyy-mm-dd" format
  //   modifiedDate = `${yyyy}-${mm}-${dd}`;
  //   const payload = {
  //     application_form_no: sessionStorage.getItem("application_form_no"),
  //     name_of_business: companyName,
  //     type_of_incorporation: selectedIncorporationOption,
  //     date_of_incorporation: modifiedDate,
  //     is_gst: gst,
  //     gst_number: (gst==="No" ?"": gstNumber) ,
  //     is_udyam: udyam,
  //     udyam_number: (udyam==="No" ?"": UdyamNumber) ,
  //     required_loan_amount: loanAmount,
  //   };
  //   const formData = new FormData();
  //   formData.append("data", encryptedData(payload));
  //   try {
  //     setShowShimmer(true);
  //     const response = await sendRequest(
  //       "/" + customerDetails.source + INSERT_SELF_EMPLOYED_DETAILS,
  //       formData
  //     );
  //     console.log(response.response);
  //     // console.log(response.Success);
  //     if (response.response.Success === true) {
  //       // setShowShimmer(true)
  //       setCustomerDetails({
  //         ...customerDetails,
  //         stage: response.response.STAGE,
  //       });
  //     }
  //     setShowShimmer(false);
  //   } catch (error) {
  //     if (error === "Unauthorised") {
  //       var route = getRouteFromLoanStageService({
  //         source: customerDetails.source,
  //         stage: "",
  //       });
  //       navigate(`${route}`, {
  //         replace: true,
  //       });
  //     } else {
  //       console.error(`Unknown Error: ${error}`);
  //       var route = getRouteFromLoanStageService({
  //         source: customerDetails.source,
  //         stage: "error",
  //       });
  //       navigate(`${route}`, {
  //         replace: true,
  //       });
  //     }
  //   }
  // };

  const insertSelfEmployedDetails = async () => {
    setShowShimmer(true);
    try {
      const payload = {
        business_address: companyAddress,
        city: city,
        state: state,
        pin_code: officePincode,
        business_name: companyName,
        employment_type: employmentType,
        business_income: income
      };
      if (gstNumber) {
        payload.gst_number = gstNumber;
      }
      const formData = new FormData();
      formData.append("data", encryptedData(payload));

      const response = await sendRequest(
        "/" + customerDetails.source + INSERT_SELF_EMPLOYED_DETAILS,
        formData
      );
      if (response.response.Success) {
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      }
      setShowShimmer(false);
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    } finally {
      setShowShimmer(false);
    }
  };

  const getOrgName = async (orgName) => {
    if (customerDetails.stage != "SELF_EMPLOYED_LEAD_CAPTURED"){
      try {
        const formData = new FormData();
        const payload = {
          company: orgName,
        };
        formData.append("data", encryptedData(payload));
        try {
          const response = await sendRequest(
            "/" + customerDetails.source + GET_ORG_NAME,
            formData
          );
          if (response.response.Success) {
  
            if (customerDetails.source === "epl") {
              response.response.data.push("Others")
              setDropDownLabels(response.response.data);
              setDropDownOptions(
                createDropDownOptions({
                  dropDownLabel: response.response.data,
                })
              );
            }
  
            if (response.response.data.length === 0) {
              setCompanyNameError(true);
              if (customerDetails.source !== "epl") {
                setDropDownLabels(["No Company Found"]);
                setDropDownOptions(
                  createDropDownOptions({
                    dropDownLabel: ["No Company Found"],
                  })
                );
              }
            } else {
              setDropDownLabels(response.response.data);
              setDropDownOptions(
                createDropDownOptions({
                  dropDownLabel: response.response.data,
                })
              );
            }
          }
        } catch (error) {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              64,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              64,
              customerDetails.application_form_number
            );
          }
          if (error === "Unauthorised") {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "",
            });
            navigate(`${route}`, {
              replace: true,
            });
          } else {
            console.error(`Unknown Error: ${error}`);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "error",
            });
            // // console.log("stage: ", customerDetails.stage);
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }
        }
      } catch (error) {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            64,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            64,
            customerDetails.application_form_number
          );
        }
        if (error === "Unauthorised") {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "",
          });
          navigate(`${route}`, {
            replace: true,
          });
        } else {
          console.error(`Unknown Error: ${error}`);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
    }
  };

  const pinCodeMaster = async (officePincode) => {
    try {
      const payload = {
        pincode: officePincode,
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      try {
        setShowShimmer(true);
        const response = await sendRequest(
          "/" + customerDetails.source + PINCODE_MASTER,
          formData
        );
        // console.log(response);
        // // console.log(response.Success);
        setShowShimmer(false);
        if (response.response.Success === true) {
          if (response.response.Data.pl_serviceable == 0) {
            setOfficePincodeError(true);
            setPincodeErrorMessage("Incorrect Pincode");
            setPincodeVerified(false);
            setCity("");
            setState("");
          } else {
            setCity(response.response.Data.city);
            setState(response.response.Data.state);
          }
        } else {
          setOfficePincodeMasterError(true);
          setOfficePincodeError(true);
          setPincodeVerified(false);
          setPincodeServiceableButtonDisabled(true);
          setPincodeInfoMessage("Required so we can service you better");
          setPincodeErrorMessage("Incorrect Pincode");
          setCity("");
          setState("");
        }
      } catch (error) {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            64,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            64,
            customerDetails.application_form_number
          );
        }
        if (error === "Unauthorised") {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "",
          });
          navigate(`${route}`, {
            replace: true,
          });
        } else {
          console.error(`Unknown Error: ${error}`);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      }
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        console.error(`Unknown Error: ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // // console.log("stage: ", customerDetails.stage);
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  const callCibil = async () => {
    // console.log("Inside callNSDL");
    try {
      const payload = {
        loan_type: "HOUSING LOAN",
        requested_loan_amount: "70000",
        source_system: "DIRECT",
        source_system_vendor: "EPL",
        env: "DEV",
        tenure: "48",
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      try {
        setShowShimmer(true);
        const response = await sendRequest(
          "/" + customerDetails.source + BUREAU_CIBIL,
          formData
        );
        // console.log(response);
        // // console.log(response.Success);
        setShowShimmer(false);
        if (response.response.Success === true) {
          setShowShimmer(true);
          // setTimeout(async () => {
          //   await beureuPolling();
          // }, 4000);
          // await beureuPolling();
          //pass
        }
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          console.error(`Unknown Error: ${error}`);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
    } catch (error) {
      // console.log(error);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  useEffect(async () => {
    if (customerDetails?.Data?.isError !== "True") {
      if (
        customerDetails.source === "upsell" ||
        customerDetails?.Data.journey_type === "preapproved"
      ) {
        setCompanyName(customerDetails.Data.org_name);
        setCompanyAddress(customerDetails.Data.org_address);
        if (customerDetails?.Data.journey_type === "preapproved") {
          setCompanyEmail(customerDetails.Data.org_email_id);
        }
        setCompanyEmailError(
          !isValidEmail(
            customerDetails.Data.org_email_id !== "None"
              ? customerDetails.Data.org_email_id
              : "" || ""
          )
        );
        // if (customerDetails.Data.office_pin_code != ""){
        if(isValidPincode(customerDetails.Data.office_pin_code)) {
          setOfficePincode(customerDetails.Data.office_pin_code);
          await pinCodeMaster(customerDetails.Data.office_pin_code);
        }
      }
    }
  }, [dataCaptured]);

  useEffect(() => {
    setIncorparationOptions(createIncorporationOptions());
    setMonthlyIncomeOptions(createMonthlyIncomeOptions());
  }, []);

  const createMonthlyIncomeOptions = (isFilter = false, filterText = "") => {
    const options = [];
    for (let i = 0; i < monthlyIncomeLabels.length; i++) {
      if (
        isFilter &&
        monthlyIncomeLabels[i]
          ?.toLowerCase()
          .indexOf(filterText.toLowerCase()) > -1
      ) {
        options.push({
          label: monthlyIncomeLabels[i],
          value: monthlyIncomeLabels[i],
          func: () => {
            setSelectedMonthlyIncomeOption(monthlyIncomeLabels[i]);
            showDropdownMI();
          },
        });
      } else if (!isFilter) {
        options.push({
          label: monthlyIncomeLabels[i],
          value: monthlyIncomeLabels[i],
          func: () => {
            setSelectedMonthlyIncomeOption(monthlyIncomeLabels[i]);
            showDropdownMI();
          },
        });
      }
    }
    return options;
  };

  const createIncorporationOptions = (isFilter = false, filterText = "") => {
    const options = [];
    for (let i = 0; i < incorporationLabels.length; i++) {
      if (
        isFilter &&
        incorporationLabels[i]
          ?.toLowerCase()
          .indexOf(filterText.toLowerCase()) > -1
      ) {
        options.push({
          label: incorporationLabels[i],
          value: incorporationLabels[i],
          func: () => {
            setSelectedIncorporationOption(incorporationLabels[i]);
            showDropdown("IC");
          },
        });
      } else if (!isFilter) {
        options.push({
          label: incorporationLabels[i],
          value: incorporationLabels[i],
          func: () => {
            setSelectedIncorporationOption(incorporationLabels[i]);
            showDropdown("IC");
          },
        });
      }
    }
    return options;
  };

  const createDropDownOptions = ({
    dropDownLabel = dropDownLabels,
    isFilter = false,
    filterText = "",
  }) => {
    // setShowShimmer(true);
    const options = [];

    for (let i = 0; i < dropDownLabel.length; i++) {
      if (companyName !== "" && companyName !== dropDownLabel[i]) {
        setCompanyNameError(true);
        if (customerDetails.source === "epl") {
          SetCompanyValid(false);
        }
      } else {
        SetCompanyValid(true);
        setCompanyNameError(false);
        break;
      }
    }
    // console.log("Creating Loan Purpose Options\n", dropDownLabel);
    // options.push(<option value="DEFAULT:disabled" key="disabled:Purpose of Loan" disabled>Purpose of Loan</option>);
    // for (let i = 0; i < dropDowns.length; i++) {
    //     options.push(<option key={i+":"+dropDowns[i]} value={dropDowns[i]}>{dropDowns[i]}</option>);
    // }
    // options.push({ label: "Purpose of Loan", value: "DEFAULT:disabled"});
    for (let i = 0; i < dropDownLabel.length; i++) {
      if (
        isFilter &&
        dropDownLabel[i]?.toLowerCase().indexOf(filterText.toLowerCase()) > -1
      ) {
        options.push({
          label: dropDownLabel[i],
          value: dropDownLabel[i],
          func: () => {
            if (dropDownLabel[i] !== "No Company Found") {
              setCompanyName(dropDownLabel[i]);
            }
            if (dropDownLabel[i] === "Others") {
              setIsOthers(true);
            } else {
              setIsOthers(false);
            }
            showDropdown();
          },
        });
      } else if (!isFilter) {
        options.push({
          label: dropDownLabel[i],
          value: dropDownLabel[i],
          func: () => {
            if (dropDownLabel[i] !== "No Company Found") {
              setCompanyName(dropDownLabel[i]);
              SetCompanyValid(true);
              setCompanyNameError(false);
            }
            if (dropDownLabel[i] === "No Company Found") {
              setCompanyName("");
              getOrgName("A");
              setCompanyNameError(true);
            }
            if (dropDownLabel[i] === "Others") {
              setIsOthers(true);
            } else {
              setIsOthers(false);
            }
            showDropdown();
          },
        });
      }
    }

    return options;
  };

  const [dropDownOptions, setDropDownOptions] = useState([]);
  // const [dropDown, setDropDown] = useState();
  const [dropDownPlaceholder, setDropDownPlaceholder] =
    useState("Organization Name");
  var defaultDropDownPlaceholderStyle = {
    // width: "100%",
    // fontSize: "20px",
    // color: "red", // "var(--color-bw_americansilver)",
    // outline: "none",
    // backgroundColor: "transparent",// "var(--color-input-bg)",
    // transition: "all 0.1s ease",
    position: "absolute",
    // content: "${(props) => props.label}";
    width: "max-content",
    left: "0.75em",
    top: "50%",
    padding: "0px 0.25em",
    transform: "translateY(-50%)",
    color: "#717171", // var(--color-bw_black);
    border: "none",
    borderRadius: "2px",
    fontSize: "20px",
    pointerEvents: "none",
    transition: "all 0.3s ease",
  };
  const [dropDownPlaceholderStyle, setDropDownPlaceholderStyle] = useState(
    defaultDropDownPlaceholderStyle
  );

  const dropDownChange = (filterText) => {
    // // console.log("dropDown Selected: ", selectedOption["value"]);
    // var e = document.getElementById("dropDown");
    // // console.log("dropDown e.value: ", e.value);
    // // console.log("dropDown e.options: ", e.options);
    // var value = e.value;
    // var text = e.options[e.selectedIndex].text;
    // // console.log(e.value);
    // // console.log("selectedOption: ", selectedOption.nativeEvent.data);
    // setDropDown(selectedOption["value"]);

    const comNameRegex = /^[a-z A-Z0-9.]+$/;
    const isValid =
      comNameRegex.test(filterText) && /[a-zA-Z0-9]/.test(filterText);

    if(!isValid) {
      setCompanyNameError(true);
      setCompanyName("");
    } else {
      setCompanyNameError(false);
      setCompanyName(filterText);
      if (filterText === "Others") {
        setIsOthers(true);
      }
      setDropDownOptions(
        createDropDownOptions({ isFilter: true, filterText: filterText })
      );
      // // console.log("selectedOption: ", e.tartget.value);
    }
  };

  const dropDownFocus = (event) => {
    // console.log("EVENT: ", event);
    // setDropDownPlaceholder("");
    var focusStyle = {
      top: "-0.5em",
      left: "0.25em",
      fontSize: "16px",
    };
    setDropDownPlaceholderStyle(focusStyle);
  };

  const blurDropDown = (event) => {
    setDropDownPlaceholderStyle(defaultDropDownPlaceholderStyle);
  };

  const showDropdown = () => {
    document.getElementById("myDropdown").classList.toggle("show");
  };

  const showDropdownGST = () => {
    document.getElementById("myDropdownGST").classList.toggle("show");
  };

  const showDropdownMI = () => {
    document.getElementById("myDropdownMI").classList.toggle("show");
  };

  const { constant } = useContext(ConstantContext);
  // console.log("constant: ", constant);
  const totalWorkExperienceOptions = constant.YEARS_OF_EXPERIENCE;
  // console.log("totalWorkExperienceOptions: ", totalWorkExperienceOptions);
  const companyNameOptions = constant.COMPANY_NAMES;
  // console.log("companyNameOptions: ", companyNameOptions);

  const { user, setUser } = useContext(UserContext);
  // const applicationFormNumber = user.application_form_no;
  // const [internalStage, setInternalStage] = useState(
  //   getInternalStage(user.Stage.stage, user.Stage.stage_status)
  // );

  // const [applicationFormNumber, setApplicationFormNumber] = useState("EPL000000009");
  const [companyName, setCompanyName] = useState("");
  const [companyNameError, setCompanyNameError] = useState(false);
  const [companyNameDisabled, setCompanyNameDisabled] = useState(false);
  const [companyNameInput, setCompanyNameInput] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyEmailDisabled, setCompanyEmailDisabled] = useState(false);
  const [companyEmailError, setCompanyEmailError] = useState(false);
  const [companyEmailErrorMessage, setCompanyEmailErrorMessage] =
    useState("Incorrect Email!");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyEmailVerified, setCompanyEmailVerified] = useState(false);
  const [karzaFailedError, setKarzaFailedError] = useState(false);
  const [companyCategoryError, setCompanyCategoryError] = useState(false);

  useEffect(() => {
    if (employmentType !== "self_employed"){
      if (companyName !== "") {
        const timeOutId = setTimeout(() => getOrgName(companyName), 1000);
        return () => clearTimeout(timeOutId);
      } else {
        getOrgName("A");
        setIsOthers(false);
      }
    }
    
  }, [companyName]);
  // const [
  //   companyEmailSendVerificationEmailButtonDisabled,
  //   setCompanyEmailSendVerificationEmailButtonDisabled
  // ] = useState(true);
  const [
    companyEmailSendVerificationButtonVisible,
    setCompanyEmailSendVerificationButtonVisible,
  ] = useState(true);
  // const [netMonthlyIncome, setNetMonthlyIncome] = useState(
  //   isValidNetMonthlyIncome(user.monthly_salary) ? user.monthly_salary : ''
  // );
  const [netMonthlyIncomeDisabled, setNetMonthlyIncomeDisabled] =
    useState(false);
  const [netMonthlyIncomeError, setNetMonthlyIncomeError] = useState(false);
  // const [netMonthlyExpense, setNetMonthlyExpense] = useState(
  //   isValidNetMonthlyExpense(user.net_monthly_expense) ? user.net_monthly_expense : ''
  // );
  const [netMonthlyExpenseDisabled, setNetMonthlyExpenseDisabled] =
    useState(false);
  const [netMonthlyExpenseError, setNetMonthlyExpenseError] = useState(false);
  const [totalWorkExperience, setTotalWorkExperience] = useState();
  // isValidTotalWorkExperience(user.years_in_current_organization)
  //   ? user.years_in_current_organization
  //   : ''
  const [totalWorkExperienceDisabled, setTotalWorkExperienceDisabled] =
    useState(false); // ('');
  const [officePincode, setOfficePincode] = useState();
  const [totalWorkExperienceError, setTotalWorkExperienceError] =
    useState(false);

  const [onSubmitButtonDisabled, setOnSubmitButtonDisabled] = useState(false);
  const [modal, setModal] = useState(false);
  const [
    officePincodeServiceableButtonDisabled,
    setOfficePincodeServiceableButtonDisabled,
  ] = useState(false);

  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [officePincodeError, setOfficePincodeError] = useState(false);
  const [officePincodeMasterError, setOfficePincodeMasterError] =
    useState(false);
  const [pincodeErrorMessage, setPincodeErrorMessage] = useState("");
  const [pincodeVerified, setPincodeVerified] = useState(false);
  const [
    pincodeServiceableButtonDisabled,
    setPincodeServiceableButtonDisabled,
  ] = useState(true);
  const [pincodeInfoMessage, setPincodeInfoMessage] = useState(
    "Required so we can service you better"
  );
  const [income, setIncome] = useState("");
  const [incomeError, setIncomeError] = useState(false);
  const [incomeErrorMessage, setIncomeErrorMessage] = useState("");
  const [companyAddressError, setCompanyAddressError] = useState(false);
  const updateCompanyName = (e) => {
    setCompanyName(e.target.value);
    setCompanyNameError(!isValidName(e.target.value));
  };
  const updateCompanyAddress = (e) => {
    setCompanyAddressError(false);
    setCompanyAddress(e.target.value);
    if (!isEnglishNewCheck(e.target.value)) {
      setCompanyAddressError(true);
    }
  };
  const [domainEmailVerified, setDomainEmailVerified] = useState(false);
  const updateCompanyEmail = (e) => {
    setCompanyEmail(e.target.value);
    setCompanyEmailError(!isValidEmail(e.target.value));
    if (!companyEmailError) {
      var commmonDomain = [
        "gmail.com",
        "yahoo.com",
        "hotmail.com",
        "mail.com",
        "yahoo.co.in",
        "yahoo.in",
        "hotmail.com",
        "Rediffmail.com",
      ];
      if (commmonDomain.includes(e.target.value.split("@")[1])) {
        setDomainEmailCheck(true);
        setDomainEmailVerified(false);
      } 
      else{
        setDomainEmailVerified(true);
      }
    }
  };

  useEffect(() => {
    let companyExepmtion = [
      "Please Choose Employer Name",
      "Please Fill Employer Name",
      "Please Provide Employer Name",
      "Please Select Employer Name",
      "Please Update Employer Name",
    ];
    if (companyExepmtion.includes(companyName)) {
      setCompanyNameError(true);
      setCompanyNameWarn(true);
    }
  }, [companyName]);

  const updateOfficePincode = async (e) => {
    setOfficePincode(e.target.value.slice(0, 6));
    if (String(e.target.value).length < 6) {
      // console.log("");
      setOfficePincodeError(true);
      setPincodeVerified(false);
      setPincodeServiceableButtonDisabled(true);
      setPincodeInfoMessage("Required so we can service you better");
      setPincodeErrorMessage("Incorrect Pincode");
      // Dummy Code
      setCity("");
      setState("");
    } else if (String(e.target.value).length === 6) {
      if (isValidPincode(e.target.value)) {
        setOfficePincodeError(false);
        setPincodeVerified(false);
        setPincodeServiceableButtonDisabled(false);
        await pinCodeMaster(e.target.value);
      }
    }
  };

  const updateTotalWorkExperience = (e) => {
    // console.log("e.label: ", e.label);
    setTotalWorkExperience(e.label);
    setTotalWorkExperienceError(e.label); //!isValidTotalWorkExperience(e.label));
  };

  const callInsertProfessionalDetailsAPI = async () => {
    // console.log("Inside callInsertProfessionalDetailsAPI");
    moengage.track_event("Professional", {
      journeyName: customerDetails.source,
      is_office_email_verified: domainEmailVerified ? "Yes" : "NO",
      "ds verified": isDSEligibilityFailed ? "NO" : "Yes", // boolean value
    });

    if (additionalConfirm === "self_employed") {
      setSelfEmpWarn(true);
    } else {
      try {
        setShowShimmer(true);
        // console.log("callInsertProfessionalDetailsAPI: try block");
        var company_name_df = document.querySelector("#company-name");
        // console.log(
        //   "callInsertProfessionalDetailsAPI: company_name_df => ",
        //   company_name_df
        // );
        const formData = new FormData();
        const requestData = {
          office_address1: companyAddress,
          city: city,
          state: state,
          pin_code: officePincode,
          company_name: isOthers ? othersCompanyName: companyName, // "ABFL - Aditya Birla Finance Limited",
          employment_type: "Salaried",
          org_email_id: companyEmail,
          monthly_income_slab: selectedMonthlyIncomeOption,
        };
        if (customerDetails.source === "epl") {
          requestData.company_type = isOthers ? companyType : null;
        }

        formData.append("data", encryptedData(requestData));
        const response = await sendRequest(
          "/" + customerDetails.source + INSERT_PROFESSIONAL_DETAILS,
          formData
        );
        setShowShimmer(false);

        // console.log("callInsertProfessionalDetailsAPI: response => ", response);
        // console.log(
        //   "callInsertProfessionalDetailsAPI: response.response.responseStatus => ",
        //   response.response.responseStatus
        // );

        if (response.response.Success === true) {
          // await karzaCallback(requestData);
          if (customerDetails.source === "epl") {
            // if (customerDetails?.Data.journey_type !== "preapproved") {
            //   await callCibil();
            // } else {
            //   await karzaAPI();
            // }
            setCustomerDetails({
              ...customerDetails,
              stage: response?.response?.STAGE,
            });
          } else if (customerDetails.source === "upsell") {
            await karzaAPI();
            // setCustomerDetails({
            //   ...customerDetails,
            //   stage: response.response.STAGE,
            // });
          }
          // await karzaAPI();
        } else {
          if (response.response.Message === "SUCCESS_REJECTED") {
            setCompanyCategoryError(true);
          }
          // Unsuccessful ResponseStatus Handling
          // console.log("Failure in KarzaAPI");
          // console.log("Ouch-2.....");
        }
        // navigate("/income-verification", {
        //   replace: true,
        //   state: {
        //     customerDetails: customerDetails
        //   },
        // }); else {
        // Unsuccessful ResponseStatus Handling
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              64,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              64,
              customerDetails.application_form_number
            );
          }
          // setShowShimmer(false);
          // console.log("callInsertProfessionalDetailsAPI: catch block: ", error);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
    }
  };

  useEffect(() => {
    var otpString = otpDigits.join("");
    if (isValidOTP(otpString)) {
      setIsOtpValid(true);
      setOtp(otpString);
    } else {
      setIsOtpValid(false);
    }
  }, [otpDigits]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
          SetEnableResendOtp(true);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  // console.log(customerDetails.stage);

  const beureuPolling = async () => {
    // console.log(customerDetails.stage);
    try {
      setShowShimmer(true);
      const formData1 = new FormData();
      const employmentCheckPayLoad = {
      };
      formData1.append("data", encryptedData(employmentCheckPayLoad));
      const { response } = await poll(
        async () =>
          await sendRequest(
            "/" + customerDetails.source + BEUREU_POLLING,
            formData1
          ),
        ({ response }) => response.Success,
        10000,
        6
      );

      // console.log("employmentCheck: ", response);
      setShowShimmer(false);
      if (response.Success === true) {
        // await dsParserCall();
      } else {
        // Unsuccessful ResponseStatus Handling
        // console.log("Unsuccess in KarzaAPI");
      }
    } catch (error) {
      // setShowShimmer(false);
      // console.log("Unknown Error: ", error);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // return false;
    }
  };
  const dsParserCall = async () => {
    try {
      setShowShimmer(true);
      const formData1 = new FormData();
      const employmentCheckPayLoad = {
      };
      formData1.append("data", encryptedData(employmentCheckPayLoad));
      const response = await sendRequest(
        "/" + customerDetails.source + DS_PARSER,
        formData1
      );
      // console.log("employmentCheck: ", response);
      if (response.response.Success) {
        await karzaAPI();
      } else {
        if (response.response.Message === "SUCCESS_REJECTED") {
          setIsDSEligibilityFailed(true);
        }
      }
      setShowShimmer(false);
    } catch (error) {
      setDsAsyncRetryModal(true);
      // setShowShimmer(false);
      // console.log("Unknown Error: ", error);
      // var route = getRouteFromLoanStageService({
      //   source: customerDetails.source,
      //   stage: "error",
      // });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      // navigate(`${route}`, {
      //   replace: true,
      // });
      // return false;
    }
  };
  const karzaAPI = async () => {
    try {
      setShowShimmer(true);
      const formData1 = new FormData();
      const employmentCheckPayLoad = {
        current_stage: customerDetails.stage,
        stage_conditions: {
          professionalDetailsChange: false,
        },
      };
      formData1.append("data", encryptedData(employmentCheckPayLoad));
      const response = await sendRequest(
        "/" + customerDetails.source + KARZA_CHECK,
        formData1
      );
      // console.log("employmentCheck: ", response);
      setShowShimmer(false);
      if (response.response.Success === true) {
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
        if (response.response.otpVerifyRequired) {
          setSeconds(10);
          setMinutes(0);
          // console.log("heereereererer>>>>>>");
          setShowOtpModal(true);
        } else {
          setCustomerDetails({
            ...customerDetails,
            stage: response.response.STAGE,
          });
          updateLead(
            customerDetails.source,
            51,
            customerDetails.application_form_number
          );
          if (customerDetails.source === "upsell") {
            callCE();
            updateLead(
              customerDetails.source,
              51,
              customerDetails.application_form_number
            );
          }
        }
      } else {
        if (response.response.Message === "SUCCESS_REJECTED") {
          setKarzaFailedError(true);
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              81,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              81,
              customerDetails.application_form_number
            );
          }
          const updated = customerDetails;
          updated.stage = response.response.STAGE;
          setCustomerDetails({
            ...updated,
          });
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      }
      // setShowShimmer(false);
      // console.log("Unknown Error: ", error);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // return false;
    }
  };

  const resendOTP = async () => {
    var payload = {
      email: companyEmail,
      mode: "EMPLOYMENT_CHECK",
    };
    try {
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + SEND_EMAIL_OTP,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        setShowOtpModal(false);
        // console.log("Otp sent");
        setShowShimmer(false);
        setResendOtp(true);
        SetEnableResendOtp(false);
        setMinutes(0);
        setSeconds(10);
        resetOTP();
      }
      if (response.response.ErrorType == "OTP_MAX_RETRY") {
        // console.log("Maximum retry reached");
        setShowShimmer(false);
        setShowMaxRetryModal(true);
        setMinutes(15);
        setSeconds(1);
        SetEnableResendOtp(false);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      }
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const VerifyOTPOnEmail = async () => {
    try {
      var payload = {
        otp: otp,
        email: companyEmail,
        mode: "EMPLOYMENT_CHECK",
        // current_stage: customerDetails.stage,
        // stage_conditions: {
        //   professionalDetailsChange: false,
        // },
      };
      setShowOtpModal(false);
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + VERIFY_EMAIL_OTP,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        setShowShimmer(false);
        // console.log("Otp Verified");
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
        if (customerDetails.source === "upsell") {
          callCE();
        }
      }
      if (response.response.ErrorType == "INVALID_OTP") {
        setShowShimmer(false);
        // console.log("incorrect");
        SetIsOtpWrong(true);
      }
      if (response.response.ErrorType == "OTP_EXPIRED") {
        setShowShimmer(false);
        setShowOtpExpiredModal(true);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const callCE = async () => {
    try {
      var payload = {
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + call_UPSELL_CE,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        //pass
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const allFieldsValidated = () => {
    // console.log(
    //   consentCheckbox,
    //   isValidName(companyName),
    //   // dropDownLabels.includes(companyName),
    //   isValidEmail(companyEmail),
    //   !isEmpty(companyAddress.trim())
    // );
    if (customerDetails.source === "epl") {
      if(isOthers && employmentType === "Salaried"){
        return (
          consentCheckbox &&
          selectedMonthlyIncomeOption != "" &&
          isValidName(companyName) &&
          companyValid &&
          othersCompanyName&&
          isCompanyType&&
          isValidOthCompName &&
          // dropDownLabels.includes(companyName) &&
          isValidEmail(companyEmail) &&
          !isEmpty(companyAddress.trim()) &&
          !companyAddressError &&
          isValidPincode(officePincode) &&
          city != "" &&
          state != ""
        );
      } 
      else if (employmentType === "self_employed") {
        return (
          consentCheckbox &&
          isValidName(companyName) &&
          isValidNumber(income) &&
          isValidPincode(officePincode) &&
          city != "" &&
          state != "" &&
          !isEmpty(companyAddress.trim()) &&
          !companyAddressError &&
          (
            !gstNumberOptions ||
            (gstNumber.length != 0 && !gstNumberError)
          )
        );
      } 
      else{
        return (
          consentCheckbox &&
          isValidName(companyName) &&
          companyValid &&
          // dropDownLabels.includes(companyName) &&
          isValidEmail(companyEmail) &&
          !isEmpty(companyAddress.trim()) &&
          !companyAddressError &&
          isValidPincode(officePincode) &&
          city != "" &&
          state != ""
        );
      }
    } else {
      return (
        consentCheckbox &&
        isValidName(companyName) &&
        // dropDownLabels.includes(companyName) &&
        isValidEmail(companyEmail) &&
        !isEmpty(companyAddress.trim()) &&
        !companyAddressError &&
        isValidPincode(officePincode) &&
        city != "" &&
        state != ""
      );
    }
  };

  useEffect(() => {
    if (gst === "Yes") {
      if (!isValidGstNumber(gstNumber)) {
        setGstNumberError(true);
      }
    } else {
      setGstNumberError(false);
    }
  }, [gst]);

  useEffect(() => {
    if (udyam === "Yes") {
      if (!isValidUDYAMNumber(UdyamNumber)) {
        setUdyamNumberError(true);
      }
    } else {
      setUdyamNumberError(false);
    }
  }, [udyam]);

  const resetOTP = async () => {
    const newOtpDigits = [...otpDigits];
    for (let i = 0; i < 6; i++) {
      newOtpDigits[i] = "";
    }
    setOtpDigits(newOtpDigits);
  };

  const inValidNumericEntries = ["e", "-"];

  const updateIncome = (e) => {
    setIncome(e.target.value);
    // console.log("e.target.value: ", e.target.value);
    if (inValidNumericEntries.includes(e.target.value)) {
      e.preventDefault();
    } else if (parseInt(e.target.value) < 0) {
      e.preventDefault();
      setIncomeError(true);
      setIncomeErrorMessage("Income should be greater than 0");
    } else if (isValidNumber(e.target.value)) {
      setCustomerDetails({
        ...customerDetails,
        income: e.target.value,
      });
      setIncomeError(false);
      setIncomeErrorMessage("");
    } else {
      setIncomeError(true);
      setIncomeErrorMessage("Please enter valid income");
    }
  };

  const handleProceedClick= async()=>{

    if(customerDetails?.Data?.lob || customerDetails?.Data?.offer_type?.startsWith("ABCDPA")){
      if (window.fbq) {
        window.fbq("track", "Salaried", { value: 0.0, currency: "USD" });
      } 
      if (window.gtag_report_conversion) {
        window.gtag_report_conversion();
      } 
    }

    if(employmentType === "self_employed"){
      if(gstNumberOptions && gstNumber !== "None Of The Above"){
        gstReturnDetails()
      }
      else{
        insertSelfEmployedDetails()
      }
    }
    else{
      callInsertProfessionalDetailsAPI()
    }
  }

  return (
    <>
      <>
        <ScenarioBasedModal
          id="bd-modal"
          isOpen={showModal}
          showCloseButton={false}
          secondButton={true}
          modalMessageHeading="Change GST Number"
          modalMessage="Do you wish to change the selected GST number?"
          modalSubmitMessagebutton2="Yes"
          onModalSubmitbutton2={handleConfirmChange}
          modalSubmitMessage="No"
          onModalSubmit={handleCloseModal}
        />
        <Modal
          open={showOtpModal}
          showCloseButton={false}
          closeonClickOutside={false}
          onClose={() => {
            // setShowOtpModal(false);
          }}
          id="bd-email-otp-parent"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div
                className="modal-body"
                style={{
                  border: "1px solid #A7A7A7",
                  padding: "1rem",
                }}
              >
                <div className="pupup-inner">
                  <div className="title text-center">
                    <h2 className="fs-36 font-weight-medium text-black mb-2 lh-1">
                      Verify Office Email{" "}
                    </h2>
                    <p className="fs-20 font-weight-medium text-black mb-4 pb-2 lh-1">
                      by entering OTP
                    </p>
                  </div>
                  <form>
                    <div
                      style={{
                        marginLeft: "10px",
                        marginRight: "10px",
                        marginTop: "15px",
                      }}
                    >
                      <div>
                        <OTPInput
                          length={6}
                          otpDigits={otpDigits}
                          setOtpDigits={setOtpDigits}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        color: "#717171",
                        fontSize: "12px",
                        marginTop: "10px",
                        marginBottom: "10px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {enableResendOtp ? (
                          <></>
                        ) : (
                          <>
                            <img
                              style={{
                                height: "15px",
                                width: "15px",
                                justifyContent: "center",
                                marginRight: "4px",
                              }}
                              src={timer}
                            />
                          </>
                        )}
                        <text
                          style={{
                            border: "None",
                            backgroundColor: "white",
                            color: enableResendOtp ? "#3C94FC" : "grey",
                            marginRight: "5px",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            resendOTP();
                          }}
                        >
                          Re-send OTP
                        </text>
                      </div>
                      {enableResendOtp ? (
                        <></>
                      ) : (
                        <>
                          <div>
                            in {minutes < 10 ? `0${minutes}` : minutes}:
                            {seconds < 10 ? `0${seconds}` : seconds}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="col-12 col-md-10 col-lg-8 col-xl-8 mx-auto">
                      <div className="col-wrap text-center">
                        <Button
                          id="VerifyOTP"
                          className="Btn VerifyOTP"
                          disabled={!isOtpValid}
                          mobile={isMobile}
                          onClick={async () => {
                            await VerifyOTPOnEmail();
                          }}
                          text={"Verify"}
                        />
                      </div>
                    </div>
                    <p
                      style={{
                        textAlign: "center",
                        paddingTop: "15px",
                      }}
                    >
                      6 digit verification code sent to office email ID will be
                      valid for next 5 minutes.
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <SelfEmployedLeadCapturedModal
          isOpen={customerDetails.stage === "SELF_EMPLOYED_LEAD_CAPTURED"}
          onClose={() => {}}
        />
        <CompanyCategoryReject
          isOpen={companyCategoryError}
          onClose={() => {
            setCompanyCategoryError(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "rejected",
            });
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }}
        />
        <CompanyNameWarnModal
          isOpen={companyNameWarn}
          onClose={() => {
            setCompanyNameWarn(false);
            setCompanyName("");
          }}
        />
        <GenericEmailCheck
          isOpen={domainEmailCheck}
          modalMessage={
            customerDetails?.source === "upsell"
              ? "Please input your official Email ID for faster loan disbursal"
              : "Please input your official Email ID to improve your chances of loan approval"
          }
          onClose={() => {
            setDomainEmailCheck(false);
          }}
        />
        <CheckInternetModal
          isOpen={internetCheck}
          onClose={() => {
            setInternetCheck(false);
            setShowShimmer(false);
          }}
        />
        <OtpExpiredModal
          isOpen={showOtpExpiredModal}
          onClose={() => {
            setShowOtpExpiredModal(false);
            setShowOtpModal(true);
            SetEnableResendOtp(false);
            setSeconds(10);
            resetOTP();
          }}
        />
        <ResendOtpEmailModal
          isOpen={resendOtp}
          onClose={() => {
            setShowOtpModal(true);
            SetEnableResendOtp(false);
            setResendOtp(false);
            setSeconds(10);
            resetOTP();
          }}
        />
        <SelfEmpWarnModal
          isOpen={selfEmpWarn}
          modalImage={icon_modal}
          onClose={() => {
            setSelfEmpWarn(false);
            setEmploymentType("Salaried");
          }}
        />
        <MaxOtpRetryModal
          isOpen={showMaxRetryModal}
          onClose={() => {
            setShowMaxRetryModal(false);
            SetEnableResendOtp(false);
            setResendOtp(false);
            setMinutes(15);
            setSeconds(1);
            resetOTP();
          }}
        />
        <DSAsyncRetryModal
          isOpen={dsAsyncRetryModal}
          onClose={() => {
            setDsAsyncRetryModal(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "error",
            });
            navigate(`${route}`, {
              replace: true,
            });
          }}
        />
        <IncorrectOtpModal
          isOpen={isOtpwrong}
          onClose={() => {
            SetIsOtpWrong(false);
            setShowOtpModal(true);
            resetOTP();
          }}
        />
        <IncorrectPinCodeModal
          isOpen={officePincodeMasterError}
          onClose={() => {
            setOfficePincodeMasterError(false);
            setOfficePincode("");
          }}
        />
        <KarzaFailed
          isOpen={karzaFailedError}
          onClose={() => {
            setKarzaFailedError(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "rejected",
            });
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }}
        />
        <DsEligibilityFailed
          isOpen={isDSEligibilityFailed}
          onClose={() => {
            setIsDSEligibilityFailed(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "rejected",
            });
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }}
        />
        <Loading open={modal === "LOADING"} />
        <Loading
          open={modal === "LOADING_CE_WAIT"}
          msg="Please wait... this may take sometime"
        />
        <Modal
          open={modal === "EMAIL_SENT"}
          onClose={() => setModal(false)}
          showCloseButton={false}
          closeOnClickOutside={false}
        >
          <ProfessionalEMailSentModal />
        </Modal>
        <Modal open={modal === "TECHNICAL_ERROR"} onClose={() => setModal("")}>
          <ErrorModal />
        </Modal>
        <Modal
          open={modal === "TECHNICAL_ERROR_CE_MAXRETRY"}
          onClose={() => setModal("")}
        >
          <ErrorModal
            heading="something went wrong!!"
            subheading="Please close the window and try again in some time."
            onClick={() => {
              setModal("");
            }}
          />
        </Modal>
        <ProfessionalDetailsWrapper className="first-child">
          <ShimmerPlaceholder
            visible={showShimmer}
            height="4em"
            marginTop="2em"
            justifyContent="flex-start"
          />
          <SubTitle
            style={{
              display: "flex",
              fontSize: "18px",
              marginTop: "10px",
              marginLeft: "5px",
            }}
            text="Employment Type"
            visible={!showShimmer}
          />
          {
						customerDetails?.Data?.isTruncated == false || customerDetails?.Data?.isTruncated === "False" ? <div
            style={{
              display: showShimmer ? "none" : "flex",
            }}
            className={"additional-confirm"}
          >
            <div style={{ display: "contents" }}>
              <input
                type="radio"
                id="Salaried"
                name="confirm-additional-detail"
                checked={employmentType === "Salaried"}
                value={"Salaried"}
                onChange={updateEmploymentType}
              />
              <label for="Salaried">Salaried</label>
            </div>
            <div style={{ display: "contents" }}>
              <input
                type="radio"
                id="Self-Employed"
                name="confirm-additional-detail"
                checked={employmentType === "self_employed"}
                value={"self_employed"}
                onChange={updateEmploymentType}
              />
              <label for="Self-Employed">Self-Employed</label>
            </div>
            <div style={{ width: "10%" }}></div>
          </div>: <></>
					}
          <form className="professional-form">
            <ShimmerPlaceholder visible={showShimmer} marginTop="0.5em" />
            {employmentType === "Salaried" ? (
              <>
                <div className="professional-form-input">
                  <FloatingInput
                    visible={!showShimmer}
                    type={"text"}
                    value={selectedMonthlyIncomeOption}
                    label={"Monthly Income"}
                    optionsMI={monthlyIncomeOptions}
                  />
                  {!showShimmer && (
                    <div
                      style={{
                        paddingBottom: "5px",
                        paddingLeft: "10px",
                        color: "#6C7174",
                      }}
                    >
                      Enter your net salary from the provided ranges. Net salary excludes taxes, bonuses, benefits, and other side income.
                    </div>
                  )}
                </div>
                {customerDetails.source === "epl" ? (
                  <div
                    style={{
                      display: showShimmer ? "none" : "flex",
                      // width: "-webkit-fill-available",
                    }}
                    id="others"
                  >
                    <p style={{ margin: "0px" }}>
                      * Please select Others, if company is not listed
                    </p>
                  </div>
                ) : (
                  <></>
                )}

                <div className="professional-form-input">
                  <FloatingInput
                    visible={!showShimmer}
                    id="CN"
                    on_change={(e) => {
                      dropDownChange(e.target.value);
                    }}
                    type={"text"}
                    value={companyName}
                    error={companyNameError}
                    error_message="Enter a valid company"
                    label={"Organization Name"}
                    options={dropDownOptions}
                  />
                </div>

                {customerDetails.source === "epl" && isOthers ? (
                  <>
                    {/* <div className="others-inputs"> */}
                    <SubTitle
                      style={{
                        display: "flex",
                        fontSize: "18px",
                        marginLeft: "5px",
                      }}
                      text="Company Type"
                      visible={!showShimmer}
                    />
                    <div
                      style={{
                        display: showShimmer ? "none" : "flex",
                        width: "-webkit-fill-available",
                        marginLeft: "10px",
                        marginTop: "0px",
                      }}
                      className={"additional-confirm"}
                    >
                      <div style={{ display: "contents" }}>
                        <input
                          type="radio"
                          id="GOVERNMENT"
                          // name="confirm-additional-detail"
                          checked={companyType === "GOVERNMENT"}
                          value={"GOVERNMENT"}
                          onChange={updateCompanyType}
                        />
                        <label for="GOVERNMENT">Government</label>
                      </div>
                      <div style={{ display: "contents" }}>
                        <input
                          type="radio"
                          id="PRIVATE"
                          // name="confirm-additional-detail"
                          checked={companyType === "PRIVATE"}
                          value={"PRIVATE"}
                          onChange={updateCompanyType}
                        />
                        <label for="PRIVATE">Private</label>
                      </div>
                      <div style={{ width: "10%" }}></div>
                    </div>

                    {/* </div> */}
                  </>
                ) : (
                  <></>
                )}

                {customerDetails.source === "epl" && isOthers ? (
                  <div style={{ width: "-webkit-fill-available" }}>
                    <FloatingInput
                      visible={!showShimmer}
                      on_change={updateOthersCompanyName}
                      type={"text"}
                      value={othersCompanyName}
                      error={!isValidOthCompName}
                      error_message="Enter a valid company Name"
                      label={"Enter Company Name"}
                    />
                  </div>
                ) : (
                  <></>
                )}

                <div className="professional-form-input">
                  <ShimmerPlaceholder visible={showShimmer} />
                  <FloatingInput
                    visible={!showShimmer}
                    value={companyEmail}
                    on_change={updateCompanyEmail}
                    error={companyEmailError}
                    error_message="Please enter a valid email"
                    type="email"
                    label={"Official Email ID"}
                  />
                  {/* {!showShimmer ? (
                    <>
                      <div
                        style={{
                          paddingBottom: "5px",
                          paddingLeft: "10px",
                          color: "#6C7174",
                        }}
                      >
                        Email ID verification is necessary or you will be asked to 
                        share your salary slip post-sanction.
                      </div>
                    </>
                  ) : (
                    <></>
                  )} */}
                </div>
                <div className="professional-form-input">
                  <ShimmerPlaceholder visible={showShimmer} />
                  <FloatingInput
                    visible={!showShimmer}
                    value={companyAddress}
                    on_change={updateCompanyAddress}
                    error={companyAddressError}
                    error_message="Please enter valid address"
                    type={"text"}
                    label={"Organization Address"}
                  />
                </div>
                <div className="professional-form-input">
                  <ShimmerPlaceholder visible={showShimmer} />
                  <FloatingInput
                    visible={!showShimmer}
                    value={officePincode}
                    on_change={updateOfficePincode}
                    error={officePincodeError}
                    error_message="Please enter a valid pin code"
                    type="Number"
                    label={"Office Pincode"}
                    // suffixIcon={
                    //   <>
                    //     <img
                    //       src={PincodeIcon}
                    //       alt="PincodeIcon.svg"
                    //       height="20"
                    //       width="20"
                    //     />
                    //   </>
                    // }
                  />
                </div>
                <div className="professional-form-input professional-form-input-small">
                  <ShimmerPlaceholder visible={showShimmer} />
                  <FloatingInput
                    visible={!showShimmer}
                    disabled={true}
                    type={"text"}
                    value={city}
                    label={"City"}
                  />
                </div>
                <div className="professional-form-input professional-form-input-small">
                  <ShimmerPlaceholder visible={showShimmer} />
                  <FloatingInput
                    visible={!showShimmer}
                    disabled={true}
                    value={state}
                    type={"text"}
                    label={"State"}
                  />
                </div>
              </>
            ) : (
              <>
                {" "}
                {customerDetails.source === "epl" ? (
                  <>
                      {gstNumberOptions &&
                        <div className="professional-form-input">
                          <ShimmerPlaceholder visible={showShimmer} />
                          <FloatingInput
                            id="GSTNumber"
                            visible={!showShimmer}
                            type={"text"}
                            value={gstNumber}
                            error={gstNumberError}
                            error_message="Select GST Number"
                            label={"GST Number"}
                            disabled={gstNumberDisabled}
                            optionsGST={gstNumberOptions}
                          />
                        </div>
                      }
                      <div className="professional-form-input">
                        <ShimmerPlaceholder visible={showShimmer} marginTop="0.5em" />
                        <FloatingInput
                          visible={!showShimmer}
                          label={"Net Monthly Income"}
                          id="income"
                          type="Number"
                          value={income}
                          error={incomeError}
                          error_message={incomeErrorMessage}
                          on_change={updateIncome}
                        />
                      </div>
                      <div className="professional-form-input">
                        <ShimmerPlaceholder visible={showShimmer} />
                        <FloatingInput
                          visible={!showShimmer}
                          value={companyName}
                          on_change={updateCompanyName}
                          disabled={companyNameDisabled}
                          type={"text"}
                          label={"Name of the Business/Company"}
                        />
                      </div>
                      <div className="professional-form-input">
                        <ShimmerPlaceholder visible={showShimmer} />
                        <FloatingInput
                          visible={!showShimmer}
                          value={companyAddress}
                          on_change={updateCompanyAddress}
                          error={companyAddressError}
                          error_message="Please enter valid address"
                          type={"text"}
                          label={"Business Address"}
                        />
                      </div>
                      <div className="professional-form-input">
                        <ShimmerPlaceholder visible={showShimmer} />
                        <FloatingInput
                          visible={!showShimmer}
                          value={officePincode}
                          on_change={updateOfficePincode}
                          error={officePincodeError}
                          error_message="Please enter a valid pin code"
                          // type={"number"}
                          type="Number"
                          label={"Business Pincode"}
                        />
                      </div>
                      <div className="professional-form-input professional-form-input-small">
                        <ShimmerPlaceholder visible={showShimmer} />
                        <FloatingInput
                          visible={!showShimmer}
                          disabled={true}
                          type={"text"}
                          value={city}
                          label={"City"}
                        />
                      </div>
                      <div className="professional-form-input professional-form-input-small">
                        <ShimmerPlaceholder visible={showShimmer} />
                        <FloatingInput
                          visible={!showShimmer}
                          disabled={true}
                          value={state}
                          type={"text"}
                          label={"State"}
                        />
                      </div>
                    {/* <div className="professional-form-input">
                      <ShimmerPlaceholder visible={showShimmer} />
                      <FloatingInput
                        visible={!showShimmer}
                        type={"text"}
                        id="IC"
                        value={selectedIncorporationOption}
                        error={""}
                        placeholder="Select Type Of Incorporation"
                        label={"Type of incorporation"}
                        disabled={false}
                        options={incorporationOptions}
                      />
                    </div>
                    <div className="professional-form-input">
                      <ShimmerPlaceholder visible={showShimmer} />
                      <FloatingInput
                        id="date"
                        on_blur={(e) => {
                          e.target.placeholder = "";
                        }}
                        on_focus={(e) => {
                          e.target.placeholder = "DDMMYYYY";
                        }}
                        visible={!showShimmer}
                        value={dateOfIncorporation}
                        placeholder="DDMMYYYY"
                        on_change={updateDateOfIncorporation}
                        type={"numText"}
                        label={"Date Of Incorporation"}
                        error={dateError}
                        disabled={false}
                        error_message={"Invalid date"}
                      />
                    </div>
                    <div className="professional-form-input">
                      <div
                        style={{
                          display: "flex",
                          fontSize: "18px",
                          color: "#747474",
                          margin: "5px 0px 0px 10px",
                        }}
                      >
                        Do you have a GST Registration?
                      </div>
                      <div
                        style={{
                          display: showShimmer ? "none" : "flex",
                          width: "-webkit-fill-available",
                          marginLeft: "10px",
                          marginTop: "0px",
                        }}
                        className={"additional-confirm"}
                      >
                        <div style={{ display: "contents" }}>
                          <input
                            type="radio"
                            id="Yes"
                            checked={gst === "Yes"}
                            value={"Yes"}
                            onChange={updateGst}
                          />
                          <label for="Yes">Yes</label>
                        </div>
                        <div style={{ display: "contents" }}>
                          <input
                            type="radio"
                            id="No"
                            checked={gst === "No"}
                            value={"No"}
                            onChange={updateGst}
                          />
                          <label for="No">No</label>
                        </div>
                        <div style={{ width: "60%" }}></div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: gst === "Yes" ? "" : "none",
                        marginTop: "5px",
                      }}
                      className="professional-form-input"
                    >
                      <ShimmerPlaceholder visible={showShimmer} />
                      <FloatingInput
                        visible={!showShimmer}
                        value={gstNumber}
                        on_change={updateGstNumber}
                        error={gstNumberError}
                        error_message="Please enter a valid GST number"
                        type="text"
                        label={"GST Number"}
                      />
                    </div>
                    <div className="professional-form-input">
                      <div
                        style={{
                          display: "flex",
                          fontSize: "18px",
                          color: "#747474",
                          margin: "5px 0px 0px 10px",
                        }}
                      >
                        Do you have a Udyam Registration?
                      </div>
                      <div
                        style={{
                          display: showShimmer ? "none" : "flex",
                          width: "-webkit-fill-available",
                          marginLeft: "10px",
                          marginTop: "0px",
                        }}
                        className={"additional-confirm"}
                      >
                        <div style={{ display: "contents" }}>
                          <input
                            type="radio"
                            id="Yes"
                            checked={udyam === "Yes"}
                            value={"Yes"}
                            onChange={updateUdyam}
                          />
                          <label for="Yes">Yes</label>
                        </div>
                        <div style={{ display: "contents" }}>
                          <input
                            type="radio"
                            id="No"
                            checked={udyam === "No"}
                            value={"No"}
                            onChange={updateUdyam}
                          />
                          <label for="No">No</label>
                        </div>
                        <div style={{ width: "60%" }}></div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: udyam === "Yes" ? "" : "none",
                        marginTop: "5px",
                      }}
                      className="professional-form-input"
                    >
                      <ShimmerPlaceholder visible={showShimmer} />
                      <FloatingInput
                        visible={!showShimmer}
                        value={UdyamNumber}
                        on_change={updateUdyamNumber}
                        error={UdyamNumberError}
                        error_message="Please enter a valid Udyam number"
                        type="text"
                        label={"Udyam Aadhar Number"}
                      />
                    </div>
                    <div className="professional-form-input">
                      <ShimmerPlaceholder visible={showShimmer} />
                      <FloatingInput
                        visible={!showShimmer}
                        value={loanAmount}
                        on_change={updateLoanAmount}
                        error={loanAmountError}
                        error_message="Please enter a loan amount between 50000 to 5000000"
                        type="Number"
                        label={"Required Loan Amount"}
                      />
                    </div> */}
                  </>
                ) : (
                  <>
                  <SelfEmpWarnModal
                    isOpen={true}
                    modalImage={icon_modal}
                    onClose={() => {
                      setEmploymentType("Salaried");
                    }}
                  />
                  </>
                )}
              </>
            )}
          </form>
          <div style={{ height: "30px" }}></div>
          <ShimmerPlaceholder
            visible={showShimmer}
            height="6em"
            marginTop="1em"
          />
          <ShimmerPlaceholder
            visible={showShimmer}
            height="2.5em"
            width="9em"
          />
          <div
            style={{ display: showShimmer ? "none" : "flex" }}
            className={"professional-form-img bottomDiv"}
          >
            <Button
              id="ProceedBtn"
              className="Btn ProceedBtn"
              disabled={!allFieldsValidated()}
              mobile={isMobile}
              onClick={
                handleProceedClick
              }
              text={"Proceed"}
            />
          </div>
        </ProfessionalDetailsWrapper>
      </>
    </>
  );
};

export default ProfessionalDetails;
